import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import M from '@materializecss/materialize';
import { logOut, registerRoutes } from '../../../func';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import Axios from 'axios';
import { useDispatch } from 'react-redux';

const AddressModal = ({ isOpen, setIsOpen, addresses, setPayToTheOrderOf }) => {
  const modal = useRef(null);

  useLayoutEffect(() => {
    if (!modal.current) return;
    M.Modal.init(modal.current, {
      onCloseEnd: () => setIsOpen(false),
    });

    return () => {
      M.Modal.getInstance(modal.current)?.destroy();
    };
  }, [modal.current]);

  const getModal = () =>
    modal.current ? M.Modal.getInstance(modal.current) : null;
  const openModal = () => getModal()?.open();
  const closeModal = () => getModal()?.close();

  useEffect(() => {
    isOpen ? openModal() : closeModal();
  }, [isOpen]);

  const cancel = e => {
    e.preventDefault();
    closeModal();
  };

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">Select An Address</h5>
          <div className="divider" />
        </div>
        <div className="row">
          {addresses
            ?.sort((a, b) => a.id - b.id)
            .map(address => {
              const {
                addressLineOne,
                addressLineTwo,
                addressLineThree,
                city,
                state,
                postalCode,
                addressType,
                isDefault,
              } = address;

              return (
                <div
                  className="card col s12"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setPayToTheOrderOf(address)
                    closeModal();
                  }}
                >
                  <div className="card-content">
                    <div className="row">
                      <b className="blue-text text-darken-4">
                        {addressType.toLocaleUpperCase()}
                      </b>
                      {isDefault && <b className="right">DEFAULT</b>}
                    </div>
                    <div className="row">
                      <p>{addressLineOne}</p>
                      <p>{addressLineTwo}</p>
                      {addressLineThree && <p>{addressLineThree}</p>}
                      <p>
                        {city} {state ? `, ${state.code}` : ''}
                      </p>
                      <p>{postalCode}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default AddressModal;
